import { render, staticRenderFns } from "./RouteCreate.vue?vue&type=template&id=245edda0&scoped=true&"
import script from "./RouteCreate.vue?vue&type=script&lang=ts&"
export * from "./RouteCreate.vue?vue&type=script&lang=ts&"
import style0 from "./RouteCreate.vue?vue&type=style&index=0&id=245edda0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "245edda0",
  null
  
)

export default component.exports